export function ClearInput(id: string) {
  (document.getElementById(id) as HTMLInputElement).value = '';
}
